import UPCard from './UPCard';

export default UPCard;
